import KanbanPage from "../../../components/kanban";
import MaintenanceTracking from "../../../components/maintenanceTracking";
import { NewUiGate } from "../../../features/newUi";

const KanbanComponent = (props: any) => {
    return (
        <NewUiGate
            legacy={<KanbanPage persona="PARTNERSHIP" {...props} />}
            next={<MaintenanceTracking persona="PARTNERSHIP" {...props} />}
        />
    );
};

const MaintenanceMonitoring = (props: any) => {
    return <KanbanComponent {...props} />;
};

export default MaintenanceMonitoring;
